<template>
  <svg class="icon" :width="width || size" :height="height || size" :viewBox="viewBox || undefined">
    <use :href="iconName" />
  </svg>
</template>
<script>
import { ref } from 'vue'
export default {
  name:'SvgIcon',
  props:{
    iconName:{
      type: String,
      default: "",
      required: true
    },
    size:{
      type: Number,
      default: 24
    },
    width:{
      type: [Number, String],
      default: null
    },
    height:{
      type: [Number, String],
      default: null
    },
    viewBox:{
      type: String,
      default: null
    }
  },
  setup(props){
    return {
      size : ref(props.size),
      width: ref(props.width),
      height: ref(props.height),
      viewBox: ref(props.viewBox),
      iconName: ref('#'+props.iconName)
    }
  }
}
</script>
